import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VisorDocumentoComponent } from './visor-documento/visor-documento.component';

const routes: Routes = [
  { path: ":idFolder", component: VisorDocumentoComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
